import { createApp } from 'vue';
import ToastNotification from '@/components/Toast.vue';

const ToastPlugin = {
  install(app) {
    const toastContainer = document.createElement('div');
    toastContainer.id = 'toast-container';
    document.body.appendChild(toastContainer);

    const toastApp = createApp(ToastNotification);
    const toastInstance = toastApp.mount(toastContainer);

    app.config.globalProperties.$toast = {
      success(title, message = '', duration = 5000) {
        toastInstance.show({ type: 'success', title, message, duration });
      },
      error(title, message = '', duration = 5000) {
        toastInstance.show({ type: 'error', title, message, duration });
      },
      warning(title, message = '', duration = 5000) {
        toastInstance.show({ type: 'warning', title, message, duration });
      },
      info(title, message = '', duration = 5000) {
        toastInstance.show({ type: 'info', title, message, duration });
      },
      show(options) {
        toastInstance.show(options);
      },
    };

    app.provide('toast', app.config.globalProperties.$toast);
  },
};

export default ToastPlugin;
